export enum EVENT_STATUS {
    COMPLETE = 'event preparation completed',
    SCHEDULED = 'event created',
    ARCHIVED = 'event cancelled',
    PREPARING = 'acknowledge receipt of prompt/work in progress'
}
